import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class IssueInvoiceDTO  {
    _originalTypeClassName = "zERP.BO.IssueInvoiceDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
IssueInvoiceDTO.translate = translateService;
}
this.CreatePaymentOrder = false;
this.CreateIncomeReceipt = false;
this.PaymentOrderDate = null;
this.IncomeReceiptDate = null;
this.PaymentOrderReason = null;
this.IncomeReceiptReason = null;
this.CreatePayment = false;
this.IssueInvoiceDTOKey = null;
this._key = this.IssueInvoiceDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
CreatePaymentOrder:any;
CreateIncomeReceipt:any;
PaymentOrderDate:any;
IncomeReceiptDate:any;
PaymentOrderReason:any;
IncomeReceiptReason:any;
CreatePayment:any;
PaymentOrderSeries:any;
IncomeReceiptSeries:any;
Payment:any;
private _IssueInvoiceDTOKey:any;
get IssueInvoiceDTOKey(): any {
    return this._IssueInvoiceDTOKey;
  }
set IssueInvoiceDTOKey(value: any) {
    this._IssueInvoiceDTOKey = value;
    this._key = value;
  }
static setPaymentOrderSeries = ($this, value) => {
var oldValue = $this.PaymentOrderSeries;
$this.PaymentOrderSeries = value;
if (value != null) {
}
}
static setIncomeReceiptSeries = ($this, value) => {
var oldValue = $this.IncomeReceiptSeries;
$this.IncomeReceiptSeries = value;
if (value != null) {
}
}
static setPayment = ($this, value) => {
var oldValue = $this.Payment;
$this.Payment = value;
if (value != null) {
}
}

static CreateDefault(): any{let issueInvoiceDTO = new Domain.IssueInvoiceDTO();
issueInvoiceDTO.CreatePaymentOrder = false;
issueInvoiceDTO.CreateIncomeReceipt = false;
Domain.IssueInvoiceDTO.setPaymentOrderSeries(issueInvoiceDTO, null);
issueInvoiceDTO.IncomeReceiptDate = null;
issueInvoiceDTO.PaymentOrderReason = null;
issueInvoiceDTO.IncomeReceiptReason = null;
Domain.IssueInvoiceDTO.setPaymentOrderSeries(issueInvoiceDTO, null);
Domain.IssueInvoiceDTO.setIncomeReceiptSeries(issueInvoiceDTO, null);
Domain.IssueInvoiceDTO.setPayment(issueInvoiceDTO, null);
return issueInvoiceDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.IssueInvoiceDTOKey == null || $this.IssueInvoiceDTOKey == 0;
            }


}